const DEFAULT_MFA_COOLDOWN_SECONDS = 10 * 60;

module.exports = {
    DEFAULT_MFA_COOLDOWN_SECONDS,
    getCooldownUntil,
    getRateLimitMessage,
    getRemainingSeconds,
    isCooldownError,
    matchesChallenge
};

const COOLDOWN_CODES = new Set([
    'MFA_CHECK_RATE_LIMITED',
    'MFA_MAX_ATTEMPTS',
    'MFA_SEND_RATE_LIMITED'
]);

function isCooldownError(error) {

    return COOLDOWN_CODES.has(error?.code);
}

function getRetryAfterSeconds(error = {}) {

    const retryAfterSeconds = Number(error.retryAfterSeconds);

    return Number.isFinite(retryAfterSeconds) && retryAfterSeconds > 0
        ? Math.ceil(retryAfterSeconds)
        : null;
}

function getCooldownUntil(error, now = Date.now()) {

    if (!isCooldownError(error)) {
        return null;
    }

    const retryAfterSeconds = getRetryAfterSeconds(error)
        || DEFAULT_MFA_COOLDOWN_SECONDS;

    return now + (retryAfterSeconds * 1_000);
}

function getRemainingSeconds(cooldownUntil, now = Date.now()) {

    const deadline = Number(cooldownUntil);

    if (!Number.isFinite(deadline)) {
        return 0;
    }

    return Math.max(0, Math.ceil((deadline - now) / 1_000));
}

function matchesChallenge({ error, mfaToken } = {}) {

    return !error?.mfaToken || error.mfaToken === mfaToken;
}

function getRateLimitMessage(error = {}) {

    const messages = {
        MFA_MAX_ATTEMPTS: 'Too many verification attempts.',
        MFA_SEND_RATE_LIMITED: 'Too many verification codes were requested.',
        MFA_VERIFY_THROTTLED: 'The verification service is temporarily busy.'
    };
    const message = messages[error.code] || error.message || 'Too many requests.';
    const retryAfterSeconds = getRetryAfterSeconds(error)
        || (isCooldownError(error) ? DEFAULT_MFA_COOLDOWN_SECONDS : null);

    if (!retryAfterSeconds) {
        return `${message} Try again shortly.`;
    }

    if (retryAfterSeconds < 60) {
        return `${message} Try again in ${retryAfterSeconds} ${retryAfterSeconds === 1 ? 'second' : 'seconds'}.`;
    }

    const minutes = Math.ceil(retryAfterSeconds / 60);

    return `${message} Try again in ${minutes} ${minutes === 1 ? 'minute' : 'minutes'}.`;
}
